export const VIEW_OPTIONS = [
  { label: 'Month', value: 'dayGridMonth', exportAvailable: true },
  { label: 'Week', value: 'timeGridWeek', exportAvailable: false },
  { label: 'Day', value: 'timeGridDay', exportAvailable: false },
  { label: 'List', value: 'listMonth', exportAvailable: false },
];
